import React, {useEffect, useState} from 'react';
import {ReactComponent as BasketIcon} from '../../../../../../assets/main/groups/online/basket.svg';
import {ReactComponent as BasketRedtIcon} from '../../../../../../assets/main/profile-box/basket-red.svg';
import {ReactComponent as PlusIcon} from '../../../../../../assets/main/groups/online/plus.svg';
import {TestCreateDescrBox} from "./test-create-descr-box/TestCreateDescrBox";
import {useAppDispatch, useAppSelector} from "common/hook";
import {
    addNewQuestion,
    deleteTestBackData,
    setTestItems,
    TestItem
} from "features/model/slice/create-test/create-test-form/createTestForm";
import {useNavigate, useParams} from "react-router-dom";
import {
    TestCreateSearch
} from "components/pages/test/test-inner-answer/test-create/test-create-item/test-create-search/TestCreateSearch";
import {message} from 'antd';
import {resetDeleteTest} from "features/model/slice/test/success-test/delete-test/deleteTest";
import {fetchCreateTest} from "features/model/service/test/fetch-create-test/fetchCreateTest";
import {resetPreservedTest} from "features/model/slice/test/success-test/preserved-test/preservedTestSlice";
import {createConfirmationModal} from "components/create-confirmation-modal/CreateConfirmationModal";
import useDeleteTestHandler from "common/hook/useDeleteTestHandler";

import {
    DragDropContext,
    Draggable,
    DraggableProvided,
    Droppable,
    DroppableProvided,
    DroppableStateSnapshot
} from 'react-beautiful-dnd';


export const TestCreateItem = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {testId} = useParams();
    const createTestForm = useAppSelector(state => state.createTestForm);
    const testItems = createTestForm.testItems;
    const published = createTestForm.published;
    const [publish, setPublish] = useState(published);
    const deleteTestData = useAppSelector(state => state.deleteTests)
    const preservedTestsData = useAppSelector(state => state.preservedTests)
    const [deleted, setDeleted] = useState<number[]>([]);
    const [submitMess, setSubmitMess] = useState(false)


    useEffect(() => {
        setPublish(published);
    }, [published]);


    const successMessageTrue = () => {
        message.success('Тест успешно удален');
    };


    const successTrue = () => {
        if (preservedTestsData.success) {
            message.success('Тест успешно сохранен');
        } else if (preservedTestsData.message) {
            message.error(preservedTestsData.message);
        }
    };


    useEffect(() => {
        if (deleteTestData.success) {
            dispatch(resetDeleteTest());
            successMessageTrue();
        }
    }, [deleteTestData.success]);


    useEffect(() => {
        if (preservedTestsData.success && submitMess) {
            dispatch(resetPreservedTest());
            successTrue();
            navigate(`/test`);
        }
    }, [preservedTestsData.success, submitMess]);


    const buildRequestData = (items: TestItem[]) => ({
        ...createTestForm,
        testItems: items,
        published: publish,
        deleted,
    });

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!testId) {
            message.error('Не удалось определить тест.');
            return;
        }

        try {
            await dispatch(fetchCreateTest({testId, requestData: buildRequestData(testItems)})).unwrap();
            setSubmitMess(true);
        } catch (error: any) {
            const errorMessage = error?.response?.data?.error
                || error?.message
                || 'Ошибка сохранения теста.';
            message.error(errorMessage);
            console.error('Произошла ошибка при отправке данных:', error);
        }
    };


    const onClickCancelHandler = async () => {
        createConfirmationModal({
            title: 'Отменить изменения',
            content: 'Вы точно хотите отменить редактирование? Введенные данные не сохранятся.',
            onOk: async () => {
                navigate(`/test/`);
            },
        });
    };


    const onClickDeleteHandler = useDeleteTestHandler();


    const handleAddQuestionClick = () => {
        dispatch(addNewQuestion());
    };


    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPublish(event.target.checked);
    };


    const handleDeleteQuestion = (id: number) => {
        const updatedTestItems = testItems.filter(item => item.id !== id);
        dispatch(deleteTestBackData(updatedTestItems));
        if (id > 0) {
            setDeleted(prevDeleteIds => [...prevDeleteIds, id]);
        }
    };


    const handleDragEnd = (result: any) => {
        if (!result.destination) {
            return;
        }

        const items = Array.from(testItems);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        const updatedItems = items.map((item, index) => ({
            ...item,
            position: index + 1,
        }));

        dispatch(setTestItems(updatedItems));
    };


    return (
        <form className="form edit-test-form" onSubmit={handleSubmit}>
            <TestCreateSearch/>

            <div className="sortable-container">
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="test-items">
                        {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
                            <div ref={provided.innerRef} {...provided.droppableProps} className="sortable-container">
                                {testItems.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                                        {(provided: DraggableProvided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                className="sortable-item"
                                                draggable={false}
                                            >
                                                <TestCreateDescrBox
                                                    questionData={item}
                                                    onDelete={handleDeleteQuestion}
                                                    dragHandleProps={provided.dragHandleProps}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

            </div>


            <div className="add-action-btn" onClick={handleAddQuestionClick}>
                <PlusIcon/>
                Добавить вопрос теста
            </div>


            <div className="btns-box aside-btns">
                <div className="col sub-col">
                    <div className="switch-box">
                        <label htmlFor="switch-btn2">Опубликовать тест</label>
                        <div className="switch-btn">
                            <input
                                id="switch-btn2"
                                type="checkbox"
                                checked={publish}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="switch-btn2" className="tooltip"></label>
                        </div>
                    </div>

                    <span className="p-icon delete-test-btn"
                          onClick={() => {
                              onClickDeleteHandler(testId);
                          }}
                    >
                             Удалить тест{' '}
                        <span className="icon">
                            <BasketRedtIcon/>
                        </span>
                    </span>
                </div>

                <div className="col btns-col">
                    <button type="submit"
                            className="btn order2-desktop"
                    >
                        <span>Сохранить изменения</span>
                    </button>

                    <button
                        type="button"
                        className="btn secondary"
                        onClick={onClickCancelHandler}
                    >
                        <span>Отменить</span>
                    </button>
                </div>
                <span className="p-icon delete-test-btn show-mobile"
                      onClick={() => onClickDeleteHandler(testId)}
                >
                    Удалить тест{' '}
                    <span className="icon">
                            <BasketIcon/>
                        </span>
                </span>
            </div>
        </form>
    );
};
